<template>
  <service_index />
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:head-actions>
      <div>
        <span style="margin-left: 2em; font-size: 2em"> Other Services </span>
        <span style="float: right; margin-right: 1em">
          <button @click="openCreateServiceModal" class="btn">
            Create Service
          </button>
        </span>
      </div>
      <hr />
    </template>
    <template v-slot:table-heading>
      <th
        width="10%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        width="20%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Service Name
      </th>
      <!-- <th
        width="15%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Category
      </th> -->
      <th
        width="15%"
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Cash Charges
      </th>
      <th
        width="15%"
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Insurance Charges
      </th>
      <th
        width="15%"
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Invoice Charges
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Actions
      </th>

      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id" style="padding: 0; margin: 0">
        <td style="padding: 2px">#{{ user.id }}</td>

        <td style="padding: 2px">
          <div class="d-flex" style="padding: 0; margin: 0">
            <div></div>
            <div
              class="d-flex flex-column justify-content-center"
              style="padding: 0; margin: 0"
            >
              <h6 class="mb-0 text-sm" style="margin: 0">
                {{ user.service_name }}
              </h6>
              <p class="text-xs text-secondary mb-0" style="margin: 0">
                {{ truncateText(user.description, 25) }}
              </p>
            </div>
          </div>
        </td>

        <!-- <td style="padding: 2px">
          <p class="text-xs font-weight-bold mb-0" style="margin: 0">
            {{ user.category_name }}
          </p>
        </td> -->

        <td class="align-middle text-center text-sm" style="padding: 2px">
          <soft-badge color="success" variant="gradient" size="sm">
            <span>{{ user.cash_charge }}</span>
          </soft-badge>
        </td>

        <td class="align-middle text-center" style="padding: 2px">
          <soft-badge color="success" variant="gradient" size="sm">
            <span>{{ user.insurance_charge }}</span>
          </soft-badge>
        </td>

        <td class="align-middle text-center text-sm" style="padding: 2px">
          <soft-badge color="success" variant="gradient" size="sm">
            <span>{{ user.invoice_charge }}</span>
          </soft-badge>
        </td>

        <td class="align-middle" style="padding: 2px; white-space: nowrap">
          <button
            @click="openEditModal(user)"
            style="
              background-color: #28a745;
              color: white;
              border: none;
              border-radius: 4px;
              padding: 3px 8px;
              font-size: 12px;
              cursor: pointer;
              margin-right: 3px;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#218838'"
            onmouseout="this.style.backgroundColor='#28a745'"
          >
            Update
          </button>

          <button
            @click="deleteService(user.id)"
            style="
              background-color: #dc3545;
              color: white;
              border: none;
              border-radius: 4px;
              padding: 3px 8px;
              font-size: 12px;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#c82333'"
            onmouseout="this.style.backgroundColor='#dc3545'"
          >
            Delete
          </button>
        </td>
      </tr>

      <!-- <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.service_name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ truncateText(user.description, 25) }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            {{ user.category_name }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">
            <span>{{ user.cash_charge }}</span>
          </soft-badge>
        </td>

        <td class="align-middle">
          <soft-badge color="success" variant="gradient" size="sm">
            <span>{{ user.insurance_charge }}</span>
          </soft-badge>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">
            <span>{{ user.invoice_charge }}</span>
          </soft-badge>
        </td>

        <td class="align-middle">
          <button @click="openEditModal(user)" class="btn-warning">
            Update</button
          >.
          <button @click="deleteService(user.id)" class="btn-danger">
            Delete
          </button>
        </td>
      </tr> -->
    </template>
  </BaseLayout>
  <CreateServiceModal
    @close-create-service-modal="closeCreateServiceModal"
    :service-to-edit="currentService"
    :edit-mode="isEditing"
    v-if="show_create_service_modal"
  />
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import BaseLayout from "../../Patients/components/table_page_layout.vue";
import CreateServiceModal from "./create_other_service_modal.vue";
import service_index from "./service_index.vue";

export default {
  name: "otherSettings",
  data() {
    return {
      users: [],
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search here...",
      searchUrl: "search_other_services",
      mainUrl: "get_other_services",
      show_create_service_modal: false,
      currentService: null,
      isEditing: false,
    };
  },
  components: {
    BaseLayout,
    CreateServiceModal,
    service_index,
  },

  methods: {
    openCreateServiceModal() {
      this.show_create_service_modal = true;
    },
    closeCreateServiceModal() {
      this.show_create_service_modal = false;
      this.currentService = null;
      this.isEditing = false;
      window.location.reload();
    },
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    openEditModal(service) {
      console.log(service);

      this.currentService = { ...service };
      this.isEditing = true;
      this.show_create_service_modal = true;
    },
    async deleteService(serviceId) {
      if (confirm("Are you sure you want to delete this service?")) {
        try {
          await generalApiRequest(
            `delete_other_medical_service/${serviceId}`,
            "POST",
            {},
            1
          );
          this.users = this.users.filter((u) => u.id !== serviceId);
        } catch (err) {
          console.error("Delete failed", err);
        }
      }
    },

    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
